import { useEffect, useState } from 'react'
import { FloatingDialog, FloatingDialogProps } from './FloatingDialog';
// import "tippy.js/dist/tippy.scss"

export type FloatingDialogComponentProps = Omit<FloatingDialogProps, 'element'> & {
  className?: string;
  children: React.ReactNode;
  updateDelay?: number;
  matchId: string
};

export const FloatingDialogComponent = (props: FloatingDialogComponentProps) => {
  const [element, setElement] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!element) {
      return
    }

    if (props.editor.isDestroyed) {
      return
    }

    const {
      editor, tippyOptions = {}, updateDelay, shouldShow = false,
    } = props
    
    const dialog = new FloatingDialog({
      updateDelay,
      editor,
      element,
      shouldShow,
      tippyOptions,
    })

    dialog.update()

    return () => dialog.destroy()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.editor, props.updateDelay, props.matchId, element, props.shouldShow])

  return (
    <div ref={setElement} className={props.className} style={{ visibility: 'hidden' }}>
      {props.children}
    </div>
  )
}
